import React from 'react';
import { useLang, useT } from '../../../../i18n';
import { exampleDate } from './exampleDate';

// Chaque événement et son compteur de présents qui monte.
const EventsVisual: React.FC = () => {
  const t = useT();
  const { lang } = useLang();
  const sat = exampleDate(lang, { weekday: 'short' });
  const sun = exampleDate(lang, { weekday: 'short' }, 1);
  const events = [
    { name: t('Cérémonie'), when: `${sat} 15:00`, color: '#9E5462' },
    { name: t('Dîner'), when: `${sat} 19:30`, color: '#2F7D5B' },
    { name: t('Brunch'), when: `${sun} 11:00`, color: '#C98A1E' },
  ];
  return (
    <div className="mk-fv-stage mk-fv-col">
      {events.map((e, i) => (
        <div key={i} className="mk-fv-box mk-fv-event">
          <span className="mk-fv-event-head">
            <b>{e.name}</b>
            <em>{e.when}</em>
          </span>
          <span className="mk-fv-event-row">
            <span className="mk-fv-track">
              <i className={`mk-fv-ev-bar${i}`} style={{ background: e.color }} />
            </span>
            <span className={`mk-fv-ev-num mk-fv-ev-num${i}`} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default EventsVisual;
